import { Breadcrumbs } from "@/components"
import { Service } from "@/components/Service"
import Layout from "@/layout"
import { NotFoundProps, getNotFoundProps } from "@/lib/notFound"
import { fetchService } from "@/lib/prismicio/service"
import { ServicePageDocument } from "@/lib/prismicio/types.generated"
import { buildPageProps } from "@/lib/ssg/slug"
import { breadcrumbArray } from "@jog/react-components"
import { RedisServiceItem, fetchS3ContentPage, retry } from "@jog/shared"
import { ServicePage, StaticPropsCommon } from "@jog/types"
import { GetStaticPropsContext } from "next"
import { GetStaticPropsResult } from "next/types"

export const buildServicePage = async (
    redisItem: RedisServiceItem,
    pageContext: GetStaticPropsContext
): Promise<GetStaticPropsResult<(StaticPropsCommon & { page: ServicePage<ServicePageDocument> }) | NotFoundProps>> => {
    const { deps, ...others } = redisItem
    if (!redisItem.deps) {
        return getNotFoundProps(pageContext)
    }
    const prismic = await retry(() =>
        pageContext.preview && pageContext.previewData
            ? fetchService(deps.uid, pageContext.previewData)
            : fetchS3ContentPage<ServicePageDocument>("service_page", deps.uid)
    )
    return buildPageProps(pageContext, { prismic, ...others })
}

export const ServicePageContent = ({ page }: { page: ServicePage<ServicePageDocument> }) => {
    return (
        <Layout>
            <Breadcrumbs list={breadcrumbArray(page.path.split("/"))} displayInMobile={true} />
            <Service prismic={page.prismic.data} />
        </Layout>
    )
}
